import validate from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/validate.js";
import legacy_45redirects_45global from "/opt/atlassian/pipelines/agent/build/middleware/legacy-redirects.global.ts";
import noindex_45if_45query_45global from "/opt/atlassian/pipelines/agent/build/middleware/noindex-if-query.global.ts";
import noindex_45if_45region_45filter_45global from "/opt/atlassian/pipelines/agent/build/middleware/noindex-if-region-filter.global.ts";
import trim_45trailing_45slash_45global from "/opt/atlassian/pipelines/agent/build/middleware/trim-trailing-slash.global.ts";
import manifest_45route_45rule from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  legacy_45redirects_45global,
  noindex_45if_45query_45global,
  noindex_45if_45region_45filter_45global,
  trim_45trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}